import ImageWithFallback from '@components/ImageWithFallback/ImageWithFallback';
import { useVideoMetadata } from '@hooks/api';
import avatarPlaceholder from '@static/vectors/placeholders/avatar-placeholder.svg';
import grayAvatar from '@static/vectors/placeholders/grey-placeholder.svg';
import videoPlaceholder from '@static/vectors/placeholders/video-placeholder.svg';
import { FormattedDate, FormattedNumber, FormattedTime } from 'react-intl';
import { setVideoPlayerVisible } from 'src/store/slices/sentinel';
import { useAppDispatch, useAppSelector } from 'universal-scripts';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import './VideoMetadata.css';

export default function VideoMetadata() {
	const dispatch = useAppDispatch();
	const videoUrl = useAppSelector((state) => state.sentinel.videoUrl);
	const isVideoPlayerVisible = useAppSelector((state) => state.sentinel.isVideoPlayerVisible);
	const metadata = useVideoMetadata(videoUrl);

	const handleTogglePlayer = () => {
		dispatch(setVideoPlayerVisible(!isVideoPlayerVisible));
	};

	return (
		<div id="video-metadata">
			<section
				style={{ backgroundImage: `url('${!isVideoPlayerVisible ? metadata.thumbnailUrl : videoPlaceholder}')` }}
				className="image-wrapper"
				onClick={handleTogglePlayer}
			>
				<div className="interactions">
					<div>
						<span className="icon icon-heart"> </span>
						<span>
							<FormattedNumber value={metadata.interactions.likes} notation="compact" maximumFractionDigits={2} />
						</span>
					</div>
					<div>
						<span className="icon icon-messages"> </span>
						<span>
							<FormattedNumber value={metadata.interactions.comments} notation="compact" maximumFractionDigits={2} />
						</span>
					</div>
					<div>
						<span className="icon icon-share"> </span>
						<span>
							<FormattedNumber value={metadata.interactions.shares} notation="compact" maximumFractionDigits={2} />
						</span>
					</div>
				</div>
			</section>
			<section title={metadata.description} className="description truncate">
				<small>{metadata.description}</small>
			</section>
			<section title={metadata.channel.name} className="channel">
				<div className="wrapper-avatars">
					<ImageWithFallback
						className="channel-avatar"
						src={metadata.channel.avatarUrl || undefined}
						fallbackSrc={avatarPlaceholder}
						alt="Channel avatar"
					/>
					{metadata?.channel?.isGray && <img className="grey-avatar" src={grayAvatar} alt="grey web avatar" />}
				</div>
				<div className="channel.info">
					<h3 className="ellipsis">{metadata.channel.name}</h3>
					<span>
						# <FormattedNumber value={metadata.channel.followers} notation="compact" maximumFractionDigits={2} />
					</span>
				</div>
			</section>
			<section title={metadata.publicationDate.toDateString()} className="date">
				<div>
					<span className="icon icon-calendar" />
					<span>
						{' '}
						<FormattedDate value={metadata.publicationDate} month="short" day="2-digit" year="numeric" />
					</span>
				</div>
				<div>
					<span className="icon icon-clock" />
					<span>
						{' '}
						<FormattedTime hour="2-digit" minute="2-digit" value={metadata.publicationDate} />
					</span>
				</div>
			</section>
			{videoUrl && <VideoPlayer url={videoUrl} />}
		</div>
	);
}
